<template>
  <!-- Same Day Delivery Modal -->
  <div
    class="modal fade"
    id="sameday_delivery"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div v-if="loader">
      <div class="spinner"></div>
    </div>
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="close_modal">
            <button type="button" data-bs-dismiss="modal" aria-label="Close">
              <i class="fi fi-rr-cross-small"></i>
            </button>
          </div>
          <div class="modal_content">
            <h2>Same Day Delivery</h2>
            <p>
              Your order will be delivered tonight between 7pm - 9pm. A $10.00 convenience Fee will be added to your cart.
            </p>

            <div class="modal_buttons">
              <button
                type="button"
                class="button secondary_button"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                No
              </button>
              <button
                type="button"
                class="button primary_button"
                @click.prevent="confirmSameDayDelivery()"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      loader: false,
    };
  },
  methods: {
    confirmSameDayDelivery() {
      this.loader = true;
      console.log("ddddd");
      var myModal = new bootstrap.Modal(
        document.getElementById("sameday_delivery")
      );

      localStorage.setItem('wash_same_day_delivery', JSON.stringify(true));
      myModal.hide();

      $("body").removeClass("modal-open");
      $(".fade").removeClass("show");
      $("body").css("padding-right", "0px");

      setTimeout(() => {
        this.loader = false;
      }, 1000);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/common/same-day-delivery-modal.vue